import { ObservableMap } from 'mobx';
import { trace } from 'owa-trace';
import type { EditorServiceModels } from '@editor/client-rest-api';

export default function deserializeOverriddenOptions(
    serializedOverriddenOptions: string
): {
    overriddenOptions: ObservableMap<string, EditorServiceModels.CritiqueTypeOption>;
    overriddenCategories: ObservableMap<string, boolean>;
} {
    const overriddenOptions = new ObservableMap<string, EditorServiceModels.CritiqueTypeOption>();
    const overriddenCategories = new ObservableMap<string, boolean>();
    if (serializedOverriddenOptions) {
        try {
            const overriddenOptionsObject = JSON.parse(serializedOverriddenOptions);
            overriddenOptionsObject?.options?.forEach(overriddenOption => {
                overriddenOptions.set(overriddenOption.id, overriddenOption);
            });

            if (overriddenOptionsObject?.categories) {
                overriddenCategories.merge(overriddenOptionsObject?.categories);
            }
        } catch (error) {
            trace.warn(`[owa-proofing-option] Error parsing overriddenOptions ${error.message}`);
        }
    }

    return { overriddenOptions: overriddenOptions, overriddenCategories: overriddenCategories };
}
